type ScoutMarkProps = {
  variant: "icon" | "glyph";
  className?: string;
  label?: string;
};

const U_PATH = "M41 68 V78 A23 23 0 0 0 87 78 V68";

export default function ScoutMark({ variant, className, label }: ScoutMarkProps) {
  const contained = variant === "icon";

  return (
    <svg
      viewBox={contained ? "0 0 128 128" : "28 15 72 99"}
      className={className}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      {label ? <title>{label}</title> : null}
      {contained ? <rect width="128" height="128" rx="29" fill="#007a74" /> : null}
      <path
        d={U_PATH}
        fill="none"
        stroke={contained ? "#fff" : "currentColor"}
        strokeWidth="18"
        strokeLinecap="round"
      />
      <circle cx="64" cy="34" r="15" fill="#e07a5f" />
    </svg>
  );
}
